import React from 'react';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import ExpiredSelectionsPopup from '../ConfigPopups/ExpiredSelectionsPopup';
import RulesPopup from '../RulesPopup/RulesPopup';
import SubHeader from '../Layout/SubHeader';
import Player from '../Player/Player';
import RoomsPanel from '../RoomsPanel/RoomsPanel';
import RoomsMenu from '../RoomsMenu/RoomsMenu';
import useWindowSize from '../../hooks/useWindowSize';
import ServerApiPopup from '../ServerApiPopup/ServerApiPopup';
import PopupManager from '../Popups/PopupManager';
import Snackbar from '../Layout/Snackbar';
import { MobilePortraitHeight, PopupState } from '../../model/constants';
import Header from '../Layout/Header';
import DebugPopup from '../DebugPopup/DebugPopup';

const Configurator = () => {
  const windowsSize = useWindowSize();
  const { isAdminPreview, popupState } = useSelector(state => state.configurator);
  const isPortrait = () => windowsSize.height > windowsSize.width;
  const isMobileLandscape = () => isMobile && windowsSize.height <= MobilePortraitHeight;

  return (
    <div className="configurator">
      {!isAdminPreview && !isMobileLandscape() && <Header isMobilePortrait={isPortrait()} />}
      {!isMobileLandscape() && <SubHeader isMobilePortrait={isPortrait()} />}
      <div className={`container-content${isMobileLandscape() ? ' is-mobile-landscape' : ''}`}>
        <Player isMobileLandscape={isMobileLandscape()} />
        {isPortrait() && !isMobileLandscape() && <RoomsMenu />}
        {!isMobileLandscape() && <RoomsPanel />}
        {!isMobileLandscape() && <Snackbar />}
        {!isMobileLandscape() && !isAdminPreview && <PopupManager />}
        {isAdminPreview && popupState === PopupState.Rules && <RulesPopup />}
        {/* process.env.NODE_ENV === 'development' && !isMobileLandscape() && <DebugPopup /> */}
      </div>
      {!isAdminPreview && <ServerApiPopup />}
      <ExpiredSelectionsPopup />
    </div>
  );
};

export default Configurator;
